import React, { useState, useEffect } from "react";
import { FiGrid, FiLayers } from "react-icons/fi";
import TabularInsights from "./TabularInsights";
import { useDispatch, useSelector } from "react-redux";
import { selectLogInUsername } from "../../../../../common/authenticateDashboard/authSlice";
import {
  fetchUserHeatmap,
  setSiteUsersDBData,
  SelectSiteHeatmapUsersWeekLabels,
  SelectSiteUserJourneyUserWeekLabels,
  setFunnelViewDBData,
  SelectSiteUsersDBData,
  setSiteHeatmapUserWeekLabels,
  setSiteUserJourneyUserWeekLabels,
  SelectSiteFunnelDBData,
  SelectCurrentSelectedPage,
  setCurrentSelectedPage
} from "../../../HeatmapXUserSegmentSlice";
import { FunnelDefaultData } from "./funnelData";
import { fetchGraphPersonaNudgeCoupon } from "../../../../Persona/components/NudgeBasedPerformance/nudgeCouponAPI";
import CustomerJourney from "../../CustomerJourney";
import OverallStatistics from "../../OverallStatistics";
import { VscGraph } from "react-icons/vsc";
import { BiSitemap } from "react-icons/bi";
import { TbActivityHeartbeat } from "react-icons/tb";
import { FirebaseDataService } from "../../../../../services/firebase-data.service";
import HeatmapTableLoading from "../../../../../components/Skeletons/HeatmapTableLoading";
import { InlineTip } from "../../../../AIAgent";


const DetailedHeatmapTable = () => {
  const dispatch = useDispatch();
  const persistedTab = useSelector(SelectCurrentSelectedPage);
  const [activeTab, setActiveTab] = useState(persistedTab || "design");
  const SiteUsersWeekLabels = useSelector(SelectSiteHeatmapUsersWeekLabels);
  const SiteUsersWeekLabelsUserJourney = useSelector(SelectSiteUserJourneyUserWeekLabels);
  const SiteUsersDBData = useSelector(SelectSiteUsersDBData);
  const siteFunnelDBData = useSelector(SelectSiteFunnelDBData);
  const firebaseDataService = new FirebaseDataService();
  const [loading, setLoading] = useState("succeeded");

  // Clear persisted tab after restoring so fresh visits start on "design"
  useEffect(() => {
    if (persistedTab) {
      dispatch(setCurrentSelectedPage(""));
    }
  }, []);
  

  // Get the logged-in user (before '@') to build API paths
  const sessionUser = useSelector(selectLogInUsername);
  const userxheatmapdbdata = useSelector((state) => state.userHeatmap.data);
  const user = sessionUser?.split("@")[0];
  const data = {}

  useEffect(() => {
    const initializeData = async () => {
      try {

        if (!user) return;
        // Get available dates tree
        const dateTree = await firebaseDataService.getAvailableDateTree(user);
        dispatch(setSiteHeatmapUserWeekLabels(dateTree));
        console.log("all Available dates fetches->",dateTree)

        const journeyDateTree = await firebaseDataService.getAvailableDateTree(user,"graph-usersegment-paths");
        dispatch(setSiteUserJourneyUserWeekLabels(journeyDateTree));
        setLoading("succeeded");

        // If we have a latest date, fetch its data
        if (dateTree) {
          const [year, month, date] = dateTree[0].split('-');
          const data = await firebaseDataService.getDataForDate(user, year, month, date);

          console.log("first time data fetched ->",data);            
          dispatch(setSiteUsersDBData({
            ...SiteUsersDBData,
            [dateTree[0]]: data.heatmap ?? {}
          }));
          dispatch(setFunnelViewDBData({
            ...siteFunnelDBData,
            [dateTree[0]] : data.journey ?? {}
          }));
          setLoading("succeeded");
        }

        // Fetch heatmap data if not already fetched
        if (Object.entries(userxheatmapdbdata).length === 0) {

          dispatch(fetchUserHeatmap(`${user}/graph-heat-map`, user, "graph-heat-map"));
        }

      } catch (error) {
        console.error('Error initializing data:', error);
      }
    };

    if (!SiteUsersWeekLabels.length) {
      console.log("SiteUsersWeekLabels changed, re-initializing if empty:", SiteUsersWeekLabels);
      setLoading("loading");
      initializeData();
    }
  }, []);

  if (loading === "loading") return <HeatmapTableLoading />;

  return (
    <div className="flex-grow p-6 mx-auto bg-white dark:bg-gray-900 rounded-lg shadow-lg">
      <InlineTip module="heatmap" />
      {/* Tab Navigation */}
      <div className="flex justify-center mb-4">
        <ul
          className="flex p-2 w-1/2 justify-center text-sm font-medium text-center text-gray-500 dark:text-gray-400
                     bg-gray-100 dark:bg-gray-800 rounded-lg shadow"
          role="tablist"
        >
          <li className="flex-1">
            <TabButton
              isActive={activeTab === "design"}
              onClick={() => setActiveTab("design")}
              icon={TbActivityHeartbeat}
              label="Heatmap View"
            />
          </li>
          <li className="flex-1">
            <TabButton
              isActive={activeTab === "explore"}
              onClick={() => setActiveTab("explore")}
              icon={BiSitemap}
              label="User Journey"
            />
          </li>
          <li className="flex-1">
            <TabButton
              isActive={activeTab === "overall"}
              onClick={() => setActiveTab("overall")}
              icon={VscGraph}
              label="OverallStatistics"
            />
          </li>
        </ul>
      </div>

      {/* Tab Content */}
      {/* <div className="mt-6 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg shadow"> */}
      <div className="mt-4">
        {activeTab === "design" ? (
          <TabularInsights />
        ) : activeTab === "overall" ? (
          <OverallStatistics data={data} />
        ) : (
          <CustomerJourney data={data} />
        )}
      </div>
    </div>
  );
};

export default DetailedHeatmapTable;

/* ---------------------------------- */
/*            Tab Button              */
/* ---------------------------------- */
const TabButton = ({ isActive, onClick, icon: Icon, label }) => {
  return (
    <button
      onClick={onClick}
      role="tab"
      aria-selected={isActive}
      className={`flex items-center justify-center gap-2 w-full py-2 px-4 
                  text-sm font-medium rounded-lg
                  transition-colors duration-200 ease-in-out focus:outline-none
                  ${
                    isActive
                      ? "bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-800 ring-1 ring-blue-300"
                      : "bg-transparent hover:bg-gray-200 dark:hover:bg-gray-600 hover:text-gray-900 dark:hover:text-white"
                  }`}
    >
      <Icon size={18} />
      {label}
    </button>
  );
};